<template>
    <header
        class="header main-site"
        :class="{
            [`theme-${layout.theme}`]: true,
            ...wrapperClasses,
        }"
    >
        <div
            v-if="isLargeDesktop"
            class="content desktop"
        >
            <div v-if="$slots.left" class="left">
                <slot name="left" />
            </div>
            <div v-if="$slots.center" class="center">
                <slot name="center" />
            </div>
            <div v-if="$slots.right" class="right">
                <slot name="right" />
            </div>
            <div v-if="$slots.bottom" class="bottom">
                <slot name="bottom" />
            </div>
        </div>
        <template v-else>
            <div v-if="$slots.left" class="left mobile">
                <slot name="left" />
            </div>
            <button class="mobile-nav" @click="layout.sidebars.right = true">
                <DSIcon
                    code="menu"
                    size="xxl"
                />
            </button>
        </template>
    </header>
</template>
<script setup>
import { inject } from '#imports';

const layout = inject('layout');

defineOptions({
    inheritAttrs: false,
});

const props = defineProps({ // eslint-disable-line
    navigation: {
        type: Array,
        required: false,
        default: () => [],
    },
    wrapperClasses: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    isLargeDesktop: {
        type: Boolean,
        required: true,
    },
});
</script>
<style scoped lang="scss">
@import '../../assets/scss/mixins';

.header {
    width: 100%;
    position: fixed;

    .mobile-nav {
        display: inline-flex;
        justify-self: end;
        -webkit-tap-highlight-color: transparent;
    }

    &.theme-clear {
        .icon.icon-menu {
            color: var(--color-base-white);
        }
    }

    &.theme-white {
        .icon.icon-menu {
            color: var(--color-base-black);
        }
    }

    .icon.icon-hamburger-two-row {
        @include default-transition();
    }

    .content {
        display: grid;
        width: 100%;
        max-width: var(--desktop-max-width);
        margin: 0 auto;
        padding: 1.25rem 1.5rem;
        grid-template-columns: auto 1fr auto;
        grid-gap: 0 1.5rem;
    }

    .center {
        display: inline-flex;
        align-items: center;
        overflow-x: hidden;
    }

    .right {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-items: flex-end;
        justify-self: end;

        > *:not(:first-child) {
            margin-left: .5rem;
        }
    }

    .bottom {
        grid-column-end: span 3;
        max-width: 100%;
        overflow: hidden;

        &:not(:empty) {
            margin-top: 4.5rem;
        }
    }
}


@media (width <= 1439px) {
    .header {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: 3rem;
        padding: .5rem 1.5rem;
        align-items: center;

        .left {
            display: inline-flex;
            justify-content: start;
        }

        .content.desktop {
            display: none;
        }
    }
}

@media (width >= 1440px) {
    .header {
        .left.mobile,
        .mobile-nav {
            display: none;
        }
    }
}
</style>
